<template>
  <div class="margin-20 d-flex flex-column">
  <div class="d-flex flex-row pointer" @click="showDish()">
    <div class="f17-l19-m flex-grow-1 two-lines-on-carousel two-lines-on-search text-truncate-on-carousel" style="height:40px;max-height:40px;word-break:break-word;white-space: break-spaces;">{{dish.sections.title.text}}</div>
    <div class="text-left " style="min-width:30%;">
      <div class="d-flex flex-row f17-l19-m" dir="rtl">
        <div class="flex-grow-1"></div>
        <PriceComponent v-if="dish.price_options.about_price.display.discounted" class="stroke margin-space-after" :value="dish.price_options.about_price.display.nominal_price" />
        <PriceComponent :value="dish.price_options.about_price.display.price || dish.price_options.about_price.display.unit_price" />
      </div>
      <div class="f14-l18 red">{{dish.price_options.about_price.display.text}}</div>
      <div class="f14-l18">{{dish.price_options.about_price.display.min_amount_text}}</div>
      <div class="f14-l18">{{dish.price_options.about_price.display.content_text}}</div>
    </div>
  </div>
  <div class="f14-l18 red bold text-truncate-on-carousel">{{dish.sections.subtitle.text || ``}}</div>
</div>
</template>
<script>
import PriceComponent from "@/components/generic/PriceComponent.vue";
import {addGoogleAnalyticsDataLayer} from '@/modules/configuration.js';
export default {
  components: {
    // DishPreferenceComponent,
    PriceComponent,
  },
  props: {
    dish: Object
  },
  methods: {
    showDish() {
      this.$router.push(this.dish.url);
      this.trackClick();
      // this.$store.dispatch('fetchDish', this.dish.url);
      // let offcanvas = document.getElementById("offcanvasExample");
      // var bsOffcanvas = new bootstrap.Offcanvas(offcanvas);
      // bsOffcanvas.show();
    },
    trackClick() {
      // Trigger Google Tag Manager event
      if (this.dish.data_layer) {
        addGoogleAnalyticsDataLayer(this.dish.data_layer);
      }
    }
  }
}
</script>